// @flow
import { connect } from 'react-redux'
import { withHandlers, withPropsOnChange, compose } from 'recompose'
import type { Notification } from './types'
import { getFirstNotification } from './selectors'
import { dismissNotification } from './actions'
import { NOTIFICATION_TYPE } from './constants'
import { getUserName } from '../session/index'
import { getPendingCheckoutForAuctionId } from '../checkout/index'
import { withRouter } from 'react-router-dom'

const alertTypes = [
  NOTIFICATION_TYPE.AUCTION_RESULT_LOST,
  NOTIFICATION_TYPE.AUCTION_RESULT_WON
]

const mapState = state => {
  const alertSelector = getFirstNotification(alertTypes)
  return function(state) {
    const alert = alertSelector(state)
    const checkout =
      alert && alert.auctionId
        ? getPendingCheckoutForAuctionId(alert.auctionId, state)
        : null
    return {
      alert,
      userName: getUserName(state),
      checkoutId: checkout ? checkout.id : null
    }
  }
}

const mapDispatch = { dismissNotification }
type ConnectProps = {
  alert: ?Notification,
  userName: string,
  checkoutId: ?string,
  dismissNotification: (id: string) => void
}
const withFirstNotificationData = connect(mapState, mapDispatch)

const withClickHandlers = withHandlers({
  onClose: props => e => {
    const { dismissNotification, alert } = props
    if (e) {
      e.preventDefault()
    }
    dismissNotification(alert.id)
  },
  onGoToCheckout: props => e => {
    const { checkoutId, alert, history, dismissNotification } = props
    dismissNotification(alert.id)
    history && checkoutId && history.push(`/checkout/${checkoutId}`)
  }
})

export type AlertProps = {
  userName: string,
  auctionTitle: string,
  wonItemCount: number,
  lostItemCount: number,
  wonItems: Array<{ id: string, item: string }>,
  lostItems: Array<{ id: string, item: string }>
}

const withAlertProps = withPropsOnChange(['alert'], (props: ConnectProps) => {
  if (!props.alert) return {}
  // TODO: perhaps do this when the notification is received???
  const parsedData = props.alert.data || { won: [], lost: [] }

  return {
    userName: props.userName,
    auctionTitle: !!props.alert && props.alert.name,
    wonItemCount: !!props.alert && props.alert.amount,
    lostItemCount: !!props.alert && props.alert.amount2,
    wonItems: parsedData.won,
    lostItems: parsedData.lost
  }
})

const AlertProvider = compose(
  withRouter,
  withFirstNotificationData,
  withAlertProps,
  withClickHandlers
)

export default AlertProvider



// WEBPACK FOOTER //
// ./src/services/notification/AlertProvider.js